var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinktree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47708 0 0 4.47708 0 10C0 15.5229 4.47708 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47708 15.5229 0 10 0ZM10.7837 15.4171H9.21625V11.8775H10.7837V15.4171ZM14.4117 9.74125H11.7317L13.6404 11.5954L12.5912 12.6488L10 10.0446L7.40833 12.6488L6.35917 11.5996L8.26792 9.74542H5.58792V8.24958H8.25542L6.35917 6.44167L7.40833 5.36708L9.21625 7.22542V4.58333H10.7837V7.22542L12.5912 5.36708L13.6404 6.44167L11.7442 8.24958H14.4117V9.74125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinktree);
export default __webpack_public_path__ + "static/media/linktree.46234861aa4a606bc258d4320ec27920.svg";
export { ForwardRef as ReactComponent };